// 商品
import UltMeta, { Meta } from "./UltMeta/index";

/**
 *  综合排序
 * */
class CommoditySort extends UltMeta {
    SYNTHESIZE = new Meta(1, "综合排序");
    DISTANCE = new Meta(2, "距离优先");
}
export const COMMODITY_SORT = new CommoditySort();
